export default () => ({
    cart : [], 
    order: null,
    modified: false,
    client:null,
    clientId:null,
    posOptions:{
        locationId:1,
        shopId:3,
        shipping_id:4,
        currencyId:1,
        taxRateId:1
    },
    cartError :{
        text:'',
        color:'red darken-3'
    },
    products:[],
    currency:"CHF",
    taxRate:null,
    categories: [],
    paymentType: '',
    email: null,
    loading: false,
    catalogId: null
})
